var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "position-relative",
      attrs: { id: "imageGallery" + _vm.id },
      on: {
        click: function ($event) {
          return _vm.registerInteraction()
        },
        mouseenter: function ($event) {
          _vm.mouseOver = true
          _vm.fadeInHint()
        },
        mouseleave: function ($event) {
          _vm.mouseOver = false
          _vm.fadeOutHint()
        },
      },
    },
    [
      _vm.getImageCount() > 1
        ? _c(
            "div",
            { staticClass: "slider", class: _vm.thumbnailPositionClasses },
            [
              _c(
                "div",
                {
                  staticClass: "slides",
                  on: {
                    scroll: function ($event) {
                      return _vm.registerInteraction()
                    },
                  },
                },
                _vm._l(_vm.singleImages, function (image, index) {
                  return _c(
                    "a",
                    {
                      key: "slide-" + index,
                      staticClass: "slide pswp-slide",
                      attrs: {
                        id: "slide-" + _vm.id + "-" + index,
                        "data-pswp-height": image.height,
                        "data-pswp-width": image.width,
                        href: image.url + ".avif",
                        title: _vm.getImageName(image),
                        itemscope: "",
                        itemtype: "https://schema.org/ImageObject",
                        target: "_blank",
                      },
                    },
                    [
                      _c("meta", {
                        attrs: {
                          content: _vm.getImageName(image),
                          itemprop: "name",
                        },
                      }),
                      _vm._v(" "),
                      _c("meta", {
                        attrs: {
                          content: _vm.$translate(
                            "Ceres::Template.headerCompanyName"
                          ),
                          itemprop: "copyrightNotice",
                        },
                      }),
                      _vm._v(" "),
                      index === 0
                        ? _c("img", {
                            attrs: {
                              alt: _vm.getAltText(image),
                              height: image.height,
                              sizes: _vm.imageSizes,
                              src: image.urlMiddle + ".avif",
                              srcset: _vm.getImageSrcSet(image),
                              width: image.width,
                              fetchpriority: "high",
                              itemprop: "contentUrl",
                            },
                          })
                        : _c("img", {
                            attrs: {
                              alt: _vm.getAltText(image),
                              height: image.height,
                              sizes: _vm.imageSizes,
                              src: image.urlMiddle + ".avif",
                              srcset: _vm.getImageSrcSet(image),
                              width: image.width,
                              decoding: "async",
                              itemprop: "contentUrl",
                              loading: "lazy",
                            },
                          }),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "slide-links",
                  class: _vm.thumbnailDisplayClasses,
                },
                _vm._l(_vm.singleImages, function (image, index) {
                  return _c(
                    "a",
                    {
                      key: "slide-link" + index,
                      attrs: { href: "#slide-" + _vm.id + "-" + index },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.scrollToImage(index)
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          alt: _vm.getAltText(image),
                          height: 300,
                          src: image.urlPreview + ".avif",
                          width: 300,
                          decoding: "async",
                          loading: "lazy",
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _c(
            "a",
            {
              key: "0",
              staticClass: "pswp-slide d-block prop-1-1",
              attrs: {
                "data-pswp-height": _vm.singleImages[0].height,
                "data-pswp-width": _vm.singleImages[0].width,
                href: _vm.singleImages[0].url + ".avif",
                title: _vm.getImageName(_vm.singleImages[0]),
                itemscope: "",
                itemtype: "https://schema.org/ImageObject",
                target: "_blank",
              },
            },
            [
              _c("meta", {
                attrs: {
                  content: _vm.getImageName(_vm.singleImages[0]),
                  itemprop: "name",
                },
              }),
              _vm._v(" "),
              _c("meta", {
                attrs: {
                  content: _vm.$translate("Ceres::Template.headerCompanyName"),
                  itemprop: "copyrightNotice",
                },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "w-100 h-100 position-absolute",
                staticStyle: { "object-fit": "contain" },
                attrs: {
                  alt: _vm.getAltText(_vm.singleImages[0]),
                  height: _vm.singleImages[0].height,
                  sizes: _vm.imageSizes,
                  src: _vm.singleImages[0].urlMiddle + ".avif",
                  srcset: _vm.getImageSrcSet(_vm.singleImages[0]),
                  width: _vm.singleImages[0].width,
                  fetchpriority: "high",
                  itemprop: "contentUrl",
                },
              }),
            ]
          ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.showHint
          ? _c(
              "div",
              {
                staticClass:
                  "slide-hints position-absolute d-flex no-pointer-events align-items-center",
                class: _vm.hintCssClasses,
                style: _vm.hintCssStyles,
              },
              [
                _vm.zoomImagePath
                  ? _c("img", {
                      staticClass: "mx-2",
                      attrs: {
                        alt: _vm.zoomTextHint,
                        src: _vm.zoomImagePath,
                        height: "24",
                        width: "24",
                      },
                    })
                  : _c("span", {
                      staticClass: "fa-2x fa fa-plus-square-o mx-2",
                    }),
                _vm._v(" "),
                _c("span", { class: { "sr-only": !_vm.showTextHint } }, [
                  _vm._v(_vm._s(_vm.zoomTextHint)),
                ]),
                _vm._v(" "),
                _vm.getImageCount() > 1 && _vm.swipeImagePath
                  ? _c("img", {
                      staticClass: "mx-2",
                      attrs: {
                        alt: _vm.swipeTextHint,
                        src: _vm.swipeImagePath,
                        height: "24",
                        width: "24",
                      },
                    })
                  : _vm.getImageCount() > 1
                  ? _c("span", { staticClass: "fa-2x fa fa-arrows-h mx-2" })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getImageCount() > 1
                  ? _c("span", { class: { "sr-only": !_vm.showTextHint } }, [
                      _vm._v(_vm._s(_vm.swipeTextHint)),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }